import { gql } from "@apollo/client";

export const CURRENCY_FRAGMENT = gql`
  fragment CurrencyFragment on Menu {
    currency {
      code
      prefix
      symbol
    }
  }
`;
